import dynamic from 'next/dynamic'
import type { Course } from '@mc/api'
import { useTranslation } from '@mc/i18n'
import { useStaticData } from '@mc/static-data-react'
import { Navigation } from 'components/Navigation'
import { JumpNav } from '../components/variant_1/JumpNav'
import { ScrollAnimation } from '../components/variant_1/ScrollAnimation'
import { Hero, CourseOverview } from '../components/variant_1/sections'
import { ANCHORS } from '../constants'
import { CM_TIMELINE_VIEW_I18N_NAMESPACE } from '../i18n'
import { VideoModalProvider } from '../providers/VideoModalProvider'
import classes from './PageContent.module.scss'

const BelowTheFold = dynamic(
  () =>
    import('../components/variant_1/BelowTheFold').then((m) => m.BelowTheFold),
  {
    ssr: false,
  },
)

export const Variant1PageContent = () => {
  const { course } = useStaticData<{ course: Course }>()
  const { t } = useTranslation(CM_TIMELINE_VIEW_I18N_NAMESPACE)

  const jumpNavItems = [
    {
      copy: t('variant_1.navigation.class'),
      anchor: ANCHORS.CLASS,
    },
    {
      copy: t('variant_1.navigation.journey'),
      anchor: ANCHORS.JOURNEY,
    },
    { copy: t('variant_1.navigation.reviews'), anchor: ANCHORS.REVIEWS },
  ]

  return (
    <div className={classes.pageContent}>
      <VideoModalProvider>
        <ScrollAnimation duration={0.7} delay={0.5} initialY={-10}>
          <Navigation /> {/* pen-5015_v1 experiment */}
        </ScrollAnimation>
        <JumpNav slug={course.slug} items={jumpNavItems} />

        <Hero />
        <CourseOverview />
        <BelowTheFold />
      </VideoModalProvider>
    </div>
  )
}
